export default {
  helpCenterUrl: 'https://help.vhtcx.com',
  sessionIdleTimeoutMinutes: 30,
  refreshIntervalMilliseconds: 30000,
  rapidRefreshIntervalMilliseconds: 15000,
  platformManagement: {
    apiUrl: process.env.REACT_APP_PLATFORM_MANAGEMENT_API_URL || '/api/platform-management',
  },
};
